import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import DetailHistoryList from 'src/components/patients/Detail/DetailHistoryList';
import DetailPatient from 'src/components/patients/Detail/DetailPatient';
import { useNotify } from 'src/context/ContextNotify';
import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

const PatientDetail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const notifyContext = useNotify();
  const patientid = searchParams.get('id');
  const token = getToken();
  const [patient, setPatient] = useState(null);
  const [logHistory, setLogHistory] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteTaskId, setDeleteTaskId] = useState('0');

  const getTemplates = () => {
    try {
      getAPI(`/patient/view?patientid=${patientid}&token=${token}`).then(
        (res) => {
          if (res && res.code === 200) {
            setPatient(res.data.patient);
          } else {
            navigate('/patients');
          }
        }
      );

      postAPI(`/master/patient-log?token=${token}`, {
        patientid: patientid,
      }).then((res) => {
        if (res && res.code === 200) {
          setLogHistory(res.data.items);
        } else {
          navigate('/patients');
        }
      });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      return;
    }
  };
  useEffect(() => {
    getTemplates();
    // eslint-disable-next-line
  }, []);

  const handleSchemaClick = () => {
    navigate(`/patient/schema?id=${patientid}`);
  };

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };
  const handleDeleteClick = (id: string) => {
    setOpenConfirm(true);
    setDeleteTaskId(id);
  };

  const handleDelete = () => {
    try {
      const token = getToken();
      postAPI(`/master/patient-delete?token=${token}`, { id: deleteTaskId }).then(
        (res) => {
          if (res && res.code === 200) {
            notifyContext.setNotifyMessage({
              show: true,
              message: '削除しました。',
              type: 'success',
            });
            navigate(`/patients`);
          }
          if (res.code === 501 || res.code === 500) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg || 'Failed to post data',
              type: 'error',
            });
          }
        }
      );
    } catch (error) {
      console.error('Failed to post data:', error);
      return;
    }
  };

  const handleUpdateClick = () => {
    navigate(`/master/patient-edit?id=${patientid}`);
  };

  return (
    <Stack direction={'row'} spacing={'20px'}>
      <Stack width={'470px'}>
        <Typography
          fontSize={'20px'}
          fontWeight={500}
          color={'primary.dark'}
          mt={'18px'}
          mb={'16px'}
        >
          患者　/ 患者詳細
        </Typography>
        <Stack direction={'row'} spacing={'20px'} width={'auto'}>
          <DetailPatient patient={patient} />
        </Stack>
      </Stack>
      <Stack flex={1}>
        <Typography
          fontSize={'20px'}
          fontWeight={500}
          color={'primary.dark'}
          mt={'18px'}
          mb={'16px'}
        >
          変更履歴
        </Typography>
        <Stack
          direction={'row'}
          spacing={'20px'}
          width={'100%'}
          sx={{
            '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before':
              { backgroundColor: '#CCD1D9' },
          }}
        >
          <SimpleBar style={{ height: '564px', width: '100%' }}>
            <DetailHistoryList logHistory={logHistory} />
          </SimpleBar>
        </Stack>
        <Stack direction={'row'} justifyContent={'space-between'} mt={'32px'}>
          <Stack direction={'row'} spacing={'8px'}>
            <BtnOutlineGradient
              text='更新'
              handleButtonClick={handleUpdateClick}
            />
            <BtnOutlineGradient
              text='カルテ'
              handleButtonClick={handleSchemaClick}
            />
          </Stack>
          {patientid && (
            <Button
              onClick={() => handleDeleteClick(patientid)}
              sx={{
                p: '0',
                width: '80px',
                height: '32px',
                backgroundColor: 'primary.light',
                borderRadius: '4px',
                '&:hover': { opacity: 0.8, backgroundColor: 'primary.light' },
                border: '2px solid #DA4453',
              }}
            >
              <Typography
                fontWeight='700'
                lineHeight={'28px'}
                height={'100%'}
                borderRadius={'2px'}
                color={'#DA4453'}
              >
                削除
              </Typography>
            </Button>
          )}
        </Stack>
      </Stack>
      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />
    </Stack>
  );
};

export default PatientDetail;
